const colorOptionArray = document.querySelectorAll('input[name="Color"]');
const productImages = Array.from( document.querySelectorAll('.product-image') );
const variantLabels = document.querySelectorAll(".swatch-input-item");

let selectedVariant;
let colorOptions = [];

function resetSlideshow() {

          let parent = document.querySelector('.product-image-slider');

          parent.slider = parent.querySelector('ul');
          parent.sliderItems = parent.querySelectorAll('li:not(.hidden)');
          parent.pageCount = parent.querySelector('.slider-counter--current');
          parent.pageTotal = parent.querySelector('.slider-counter--total');
          parent.prevButton = parent.querySelector('button[name="previous"]');
          parent.nextButton = parent.querySelector('button[name="next"]');
      
          if (!parent.slider || !parent.nextButton) return;
      
          const resizeObserver = new ResizeObserver(entries => parent.initPages());
          resizeObserver.observe(parent.slider);
      
          parent.slider.addEventListener('scroll', parent.update.bind(parent));
          parent.prevButton.addEventListener('click', parent.onButtonClick.bind(parent));
          parent.nextButton.addEventListener('click', parent.onButtonClick.bind(parent));
        }
      
        function initPages() {
          if (!parent.sliderItems.length === 0) return;
          parent.slidesPerPage = Math.floor(parent.slider.clientWidth / parent.sliderItems[0].clientWidth);
          parent.totalPages = parent.sliderItems.length - parent.slidesPerPage + 1;
          parent.update();
        }
        
      
        function update() {
          if (!parent.pageCount || !parent.pageTotal) return;
          parent.currentPage = Math.round(parent.slider.scrollLeft / parent.sliderItems[0].clientWidth) + 1;
      
          if (parent.currentPage === 1) {
            parent.prevButton.setAttribute('disabled', true);
          } else {
            parent.prevButton.removeAttribute('disabled');
          }
      
          if (parent.currentPage === parent.totalPages) {
            parent.nextButton.setAttribute('disabled', true);
          } else {
            parent.nextButton.removeAttribute('disabled');
          }
      
          parent.pageCount.textContent = parent.currentPage;
          parent.pageTotal.textContent = parent.totalPages;
        }
      
        function updateSlider(evt) {
          evt.preventDefault();
          const slideScrollPosition = evt.currentTarget.name === 'next' ? parent.slider.scrollLeft + parent.sliderItems[0].clientWidth : parent.slider.scrollLeft - parent.sliderItems[0].clientWidth;
          parent.slider.scrollTo({
            left: slideScrollPosition
          });
  
} 

// Checks how many images are displayed. Conditionally hides slider nav
function checkNav() {
    let displayedImages = document.querySelectorAll(".img-show");
    let sliderNav = document.querySelector(".slider-buttons");
    if (displayedImages.length === 1) {
        sliderNav.classList.add("hidden");
    } else if (sliderNav.classList.contains("hidden")) {
        sliderNav.classList.remove("hidden");
    }
}

// Captures color values
for (let i = 0; i < colorOptionArray.length; i++) {
    let optionName = colorOptionArray[i].value;
    optionName = optionName.replaceAll(" ", "-");
    optionName = optionName.toLowerCase();
    colorOptions.push(optionName);
    if (colorOptionArray[i].checked) {
        selectedVariant = optionName;
        let label = document.getElementById('label-color');
        let labelText = optionName.replaceAll('-', ' ');
        label.textContent = labelText;
    }
}

// Captures image color assignments via alt-text tags and updates alt-text
for (let i = 0; i < productImages.length; i++) {
    let imageAlt = productImages[i].getAttribute("alt");
    if (imageAlt.includes("#color_")) {
        let altString = imageAlt.split("#color_");
        let altText = altString[0];
        let colorVariant = altString[1];
        productImages[i].alt = altText;
        productImages[i].setAttribute("variant-image", colorVariant);
    } else {
        productImages[i].setAttribute("variant-image", "all");
    }
    let variantImageValue = productImages[i].getAttribute("variant-image");
    if (variantImageValue !== selectedVariant && variantImageValue !== "all") {
        let imageWrapper = productImages[i].closest(".slider__slide");
        imageWrapper.classList.add("hidden");
    } else {
        let imageWrapper = productImages[i].closest(".slider__slide");
        imageWrapper.classList.add("img-show");
    }
}

// Listens for variant click, re-evaluates images displayed.
for (let i = 0; i < variantLabels.length; i++) {
    variantLabels[i].addEventListener("click", function() {
        let clickedVariant = this.getAttribute("variant-image-group");
        for (let i = 0; i < productImages.length; i++) {
            let imageWrapper = productImages[i].closest(".slider__slide");
            imageWrapper.classList.add('hidden')
            imageWrapper.classList.remove("img-show");
            let variantImageValue = productImages[i].getAttribute("variant-image");
            if (variantImageValue === clickedVariant || variantImageValue === "all") {
                imageWrapper.classList.remove("hidden");
                imageWrapper.classList.add("img-show");
            }
        }
        let labelParent = variantLabels[i].closest('.product-form__input');
        let label = labelParent.querySelector('.caption-with-letter-spacing');
        let labelText = clickedVariant.replaceAll('-', ' ');
        label.textContent = labelText;
        resetSlideshow();
        checkNav();

    });
}

checkNav();